import { NewOpoForm } from '@lp/features/admin/forms';
import { PatchOpoOrganizationRequestBody } from '@/api/apis/opo';
import { convertToIanaTimezone } from '@/utils/helpers';

export { createLocationFormValidation as createOpoFormValidation } from '@lp/features/admin/forms/utils';

export const getOpoOrganizationBody = (data: NewOpoForm): PatchOpoOrganizationRequestBody => {
  return {
    name: data.name,
    code: data.code,
    location: {
      country: data.country,
      state: data.state,
      city: data.city,
      addressLine: data.addressLine,
      postalCode: data.postalCode,
      timezone: data.timezoneIANA || convertToIanaTimezone(data.timezone),
    },
    primaryContactId: data.primaryContactId,
  };
};
